import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useToast } from "../Toast/ToastContext";
import { resetErrAction } from "../../redux/slices/globalActions/globalActions";

const ErrorMsg = ({ message }) => {
  const dispatch = useDispatch();
  const { showToast, dismissToast } = useToast();
  
  useEffect(() => {
    const id = showToast(message, "error");

    // Espera un poco más que la duración del toast (3000ms) antes de limpiar el error en Redux
    const resetTimer = setTimeout(() => {
      dispatch(resetErrAction());
    }, 3200);

    return () => {
      dismissToast(id);
      clearTimeout(resetTimer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message]);
  
  return null;
};

export default ErrorMsg;